import { createContext, useContext } from 'react';

export interface CancelChangesRequester {
  (callback: () => void): void;
}

const CancelChangesRequesterContext = createContext<CancelChangesRequester>(
  callback => callback(),
);

export default CancelChangesRequesterContext;

export const useCancelChangesRequester = () =>
  useContext(CancelChangesRequesterContext);
